import { Box } from "@mui/material"
import { Icon } from "@iconify/react";

export const quotationTableHeader = [
    { field: 'sl_no', headerName: 'Serial No', width: 80 },
    // { field: 'requirementID', headerName: 'Requirement ID', width: 120 },
    { field: 'product_name', headerName: 'Product', width: 250 },

    {
      field: "is_viewed",
      headerName: "Quotation Checked",
      width: 150,
      renderCell: (params) => {
        if (params.row.is_viewed) {
          return(
            <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
           <Icon icon="healthicons:yes"width="20" height="20"  style={{color: '#45d01b', marginRight: '4px',}} />
            YES
          </Box>
          )
         
        } else  {
          return (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon icon="healthicons:no" width="20" height="20"  style={{color: '#d01b1b', marginRight: '4px',}} />
              NO
            </Box>
          )
        }
      },
    },
    {
      field: "is_checked",
      headerName: "Quotation Closed",
      width: 150,
      renderCell: (params) => {
        if (params.row.is_checked) {
          return(
            <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
           <Icon icon="healthicons:yes"width="20" height="20"  style={{color: '#45d01b', marginRight: '4px',}} />
            YES
          </Box>
          )
         
        } else  {
          return (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon icon="healthicons:no" width="20" height="20"  style={{color: '#d01b1b', marginRight: '4px',}} />
              NO
            </Box>
          )
        }
      },
    },
    { field: 'createdAt', headerName: 'Created At', width: 220,
      renderCell: ({ value }) => {
        if (!value) return "";
    
        const date = new Date(value);
        const formattedDate = date.toISOString().split("T")[0]; // Extract YYYY-MM-DD
        const formattedTime = date.toLocaleString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
    
        return `${formattedDate} ${formattedTime}`;
      },
     },
    {
      field: 'approvedBy',
      headerName: 'Quotation Approved By',
      width: 300,
        valueGetter: (params) => (params.row.approvedBy ? params.row.approvedBy : "N/A"),
    },
  ]
